export default __webpack_public_path__ + "static/media/2-min.7bd4725b.jpg";